module.exports = __webpack_public_path__ + "static/img/bg-subscribe-slider.74fe0da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-subscribe-slider.png
// module id = /Znx
// module chunks = 1